import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { OverledenIcon } from "../../atoms/icons/OverledenIcon";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<boolean>;
export const Overleden = (props: AllProps) => {
    const { t } = useTranslation('client');
    
    const formatDeceased = (isDeceased: boolean) => {
        return isDeceased ? t('deceased.yes', 'Ja') : t('deceased.no', 'Nee');
    };

    return (<Caption {...props} caption={props.label || t('deceased', 'Overleden')} icon={<OverledenIcon />}>
        {formatDeceased(props.value)}
    </Caption>)
}

